import type { Effect, Reducer, Subscription } from '@umijs/max';
import type { UserButieLogType } from './data';
import { getUserButieLogPage } from './service';

export type UserButieLogState = {
  code: number;
  type: string;
  message: string;
  total: number;
  current: number;
  pageSize: number;
  items: UserButieLogType[];
};

type UserButieLogModelType = {
  namespace: string;
  state: UserButieLogState;
  reducers: {
    UserButieLogReducer: Reducer<UserButieLogState>;
  };
  effects: {
    fetchUserButieLogPageEffect: Effect;
    refreshDataEffect: Effect;
  };
  subscriptions: {
    setup: Subscription;
  };
};

const UserButieLogModel: UserButieLogModelType = {
  namespace: 'userButieLog',
  state: {
    code: 0,
    type: '',
    message: 'success',
    items: [],
    total: 0,
    pageSize: 20,
    current: 1,
  },

  reducers: {
    UserButieLogReducer(state, action) {
      const payload = action.payload || {};
      return {
        ...state,
        ...payload,
        items: payload.data?.items || [],
        total: payload.data?.total || 0,
        current: payload.data?.current || 1,
        pageSize: payload.data?.pageSize || 20,
      } as UserButieLogState;
    },
  },

  effects: {
    *fetchUserButieLogPageEffect(
      { payload: { pageSize, current, filter, sorter } }: any,
      { put, call }: any,
    ): Generator<any, void, any> {
      try {
        const res: any = yield call(getUserButieLogPage, {
          pageSize,
          current,
          filter,
          sorter,
        });
        yield put({
          type: 'UserButieLogReducer',
          payload: res,
        });
      } catch (e) {
        console.error('Fetch data failed:', e);
      }
    },

    // 通用刷新数据的 effect
    *refreshDataEffect(
      { payload: action }: any,
      { put, select }: any,
    ): Generator<any, void, any> {
      const current = yield select((state: any) => state.userButieLog.current);
      const pageSize = yield select((state: any) => state.userButieLog.pageSize);
      yield put({
        type: 'fetchUserButieLogPageEffect',
        payload: {
          current,
          pageSize,
          filter: { ...action.filter },
          sorter: action.sorter || [],
        },
      });
    },
  },

  subscriptions: {
    setup() {},
  },
};

export default UserButieLogModel;
